module.exports = __webpack_public_path__ + "static/final-tpm-1-a7abd9bb868314aee9fa0823e50ff38d.jpg";